module.exports = __webpack_public_path__ + "static/media/me.27726ff1.svg";